"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AdminOnlyWrapper = _interopRequireDefault(require("ui-addon-upgrades/_core/common/components/AdminOnlyWrapper"));

var _default = _AdminOnlyWrapper.default;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/decorators/UIAdminOnlyWrapper.js
// module id = 282
// module chunks = 5 6